"use client"
import * as React from "react"
import firebase from "firebase"
import { navigate } from "gatsby"
import config, { firebaseInit } from "../../config"
import ContentPageLayout from "../../components/ContentPageLayout"
import CommunityContentLayout from "../../components/CommunityContentLayout"

const SeasonsPage = ({ location }) => {
  const [season, setSeason] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState("")
  React.useEffect(() => {
    firebaseInit(firebase)
    return firebase.auth().onAuthStateChanged(async user => {
      if (!user) return navigate("/")
      try {
        const token = await user.getIdToken(true)
        const response = await fetch(`${config.serverUri}/seasons/current`, { headers: { "x-sc-signature": token } })
        if (!response.ok) throw new Error("No fue posible cargar la temporada")
        const data = await response.json(); setSeason(data.season)
      } catch (reason) { setError(reason.message) } finally { setLoading(false) }
    })
  }, [])
  return <ContentPageLayout location={location}><CommunityContentLayout>
    <section className="w-full px-5 py-8 md:px-10">
      <h1 className="text-3xl font-bold mb-6">Temporadas</h1>
      {loading && <p>Cargando temporada...</p>}{error && <p role="alert" className="text-red-600">{error}</p>}
      {!loading && !error && !season && <div className="rounded-lg bg-gray-100 p-8 text-center"><h2 className="text-xl font-bold">No hay una temporada activa</h2><p>Vuelve pronto para descubrir nuevos entrenamientos.</p></div>}
      {season && <>
        {season.banner && <img src={season.banner.url && !season.banner.url.startsWith("http") ? `${config.serverUri}${season.banner.url}` : season.banner.url} alt="" className="w-full rounded-lg object-cover mb-6" style={{maxHeight:360}} />}
        <h2 className="text-2xl font-bold">{season.name}</h2>{season.subtitle && <p className="text-lg">{season.subtitle}</p>}
        <div className="my-5" aria-label={`Progreso ${season.progress}%`}><div className="flex justify-between mb-2"><b>Tu progreso</b><span>{season.completed} de {season.total}</span></div><div className="w-full h-3 rounded-full bg-gray-200"><div className="h-3 rounded-full bg-sc-primary" style={{width:`${season.progress}%`}} /></div></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">{season.items.map(item => <article key={item.id} className="rounded-lg shadow overflow-hidden bg-white">
          {item.media && item.media[0] && <img src={item.media[0].url.startsWith("http") ? item.media[0].url : `${config.serverUri}${item.media[0].url}`} alt="" className="w-full h-40 object-cover" />}
          <div className="p-4"><div className="flex justify-between"><h3 className="font-bold">{item.title}</h3>{item.completed && <span className="text-sc-primary" aria-label="Completado">✓</span>}</div><p>{item.description}</p><button className="mt-3 px-4 py-2 rounded bg-black text-white" onClick={() => navigate(`/content/workouts/${item.id}`)}>{item.completed ? "Volver a ver" : "Entrenar"}</button></div>
        </article>)}</div>
      </>}
    </section>
  </CommunityContentLayout></ContentPageLayout>
}
export default SeasonsPage
